import axios from 'axios';
import * as Sentry from '@sentry/react';

const api = axios.create({
  baseURL: import.meta.env.VITE_APP_BACKEND_URL || window.location.origin,
  timeout: 10000,
  withCredentials: true,
});

// Attach JWT token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => {
    // Unwrap the standard { status, statusCode, message, result } envelope
    console.log(response)
    if (response.data?.status === 'success' && response.data?.result !== undefined) {
      response.data = response.data.result;
    }
    return response;
  },
  (error) => {
    const statusCode = error.response?.status;
    const authPaths = ['/login', '/crear-cuenta'];

    // Report server errors (5xx) and unexpected client errors to Sentry
    if (statusCode >= 500 || (!statusCode && error.code !== 'ERR_CANCELED')) {
      Sentry.captureException(error, {
        tags: { component: 'api' },
        extra: {
          url: error.config?.url,
          method: error.config?.method,
          status: statusCode,
        },
      });
    }

    if (statusCode === 401 && !authPaths.includes(window.location.pathname)) {
      localStorage.clear();
      window.location.replace(`${window.location.origin}/login`);
    }
    return Promise.reject(error);
  }
);

export default api;
